module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Licenses")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('date-range-picker', {
    on: {
      "daterange-change": _vm.dateRangeChange
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('h5', [_vm._v(_vm._s(_vm.dateRangeFormat(_vm.dateStart)) + " - " + _vm._s(_vm.dateRangeFormat(_vm.dateEnd)))])])]), _vm._v(" "), _c('p', [_vm._v("Showing " + _vm._s(_vm.licenseCount) + " licenses")]), _vm._v(" "), _vm._l((_vm.sortedLicenses), function(lic) {
    return _c('div', {
      staticClass: "panel panel-default"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_vm._v("\n      " + _vm._s(lic.license.key) + "\n    ")]), _vm._v(" "), _c('span', [_vm._v("Issued - " + _vm._s(_vm.formatDate(lic.license.issued)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(lic.license.numActivations) + " / " + _vm._s(lic.license.maxInstances) + " activations")]), _vm._v(" "), _c('div', {
      staticClass: "table-responsive"
    }, [_c('table', {
      staticClass: "table"
    }, [_c('thead', [_c('tr', _vm._l((lic.attributes.license.service), function(service, name) {
      return _c('th', [_vm._v("\n            " + _vm._s(name) + "\n          ")])
    }))]), _vm._v(" "), _c('tbody', [_c('tr', _vm._l((lic.attributes.license.service), function(service) {
      return _c('td', [(service.enabled === 'true') ? _c('span', {
        staticClass: "glyphicon glyphicon-ok",
        attrs: {
          "aria-hidden": "true"
        }
      }) : _vm._e()])
    }))])])]), _vm._v(" "), (lic.activations.length > 0) ? _c('div', [_c('table', {
      staticClass: "table"
    }, [_vm._m(0, true), _vm._v(" "), _c('tbody', _vm._l((lic.activations), function(activation) {
      return _c('tr', {
        class: _vm.expiresRowClass(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration)
      }, [_c('td', [_vm._v(_vm._s(_vm.formatDate(activation.activateTime)))]), _vm._v(" "), _c('td', [_c('router-link', {
        attrs: {
          "to": {
            name: 'serial',
            params: {
              id: activation.serial
            }
          }
        }
      }, [_vm._v(_vm._s(_vm.trim(activation.serial, 8)))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.serialDetails[activation.serial] ? _vm.serialDetails[activation.serial].customer : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseExpiryDate(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration).format('YYYY-MM-DD HH:mm')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.licenseExpiryDate(activation.activateTime, lic.attributes.license.root.expires, lic.attributes.license.root.duration).fromNow()))]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(activation.installed === 1 ? 'yes' : 'no'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(activation.installInfo))])])
    }))])]) : _c('div', [_c('span', [_vm._v("No license activations.")])])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Activation Date")]), _vm._v(" "), _c('th', [_vm._v("Serial")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Expiry Date")]), _vm._v(" "), _c('th', [_vm._v("Expires In")]), _vm._v(" "), _c('th', [_vm._v("Installed")]), _vm._v(" "), _c('th', [_vm._v("Info")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-26c9619c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/License.vue
// module id = 490
// module chunks = 2